import React from "react";
import TodayAppointments from "./TodayAppointments";

const DoctorHome = () => {
  return (
    <div>
      <TodayAppointments />
    </div>
  );
};

export default DoctorHome;